/* Project Import will be here */
import smartListConstants from './smartListConstant';
/* Project Import will be here */

const initialState = {
    groupIds: [],
    group: {},
    isLoading: false,
    ids: [],
    data: {},
    count: null,
    error: null,
    originalData: []
};

export const smartListProducts = (state = initialState, action) => {
    switch (action.type) {
        case smartListConstants.SMART_LIST_PRODUCTS_REQUEST:
            return {
                ...initialState,
                isLoading: true
            };
        case smartListConstants.SMART_LIST_PRODUCTS:
            return {
                ...state,
                ...action.payload,
                error: null,
                isLoading: false
            };
        case smartListConstants.SMART_LIST_PRODUCTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error
            };
        case smartListConstants.RESET_SMART_LIST_PRODUCTS:
            return {
                ...initialState
            };
        case smartListConstants.SMART_LIST_PRODUCT_UPDATE_IS_FAV:
            let { ProductId, IsFavourite } = action.payload;
            if (ProductId in state.data) {
                return {
                    ...state,
                    data: { ...state.data, [ProductId]: { ...state.data[ProductId], IsFavourite: IsFavourite === 0 ? 1 : 0 } },
                    error: null,
                    isLoading: false
                }
            }
            else {
                return state;
            }
        default:
            return state;
    }
};